import React, { useEffect } from 'react';
import '../../css/Admin.css';
import AdminSidebar from '../../components/Sidebar/AdminSidebar';
import Container from 'react-bootstrap/Container';
import { useAppDispatch } from '../../context/store';
import { Button } from 'react-bootstrap';
import { useToggle } from 'react-use';
import { getEmailNotificationsGroupsAsync } from '../../slices/admin/emailNotificationsSlice';
import EmailNotificationsGroup from '../../components/Modals/EmailNotificationsGroup';
import EmailNotificationsGroupTable from '../../components/Tables/EmailNotificationsGroupTable';
import { EMAIL_GROUP_TYPES, EVENT_STATUS_TYPES } from '../../lib/constants';
import { EmailGroupType, EventStatusType } from '../../lib/types';

const styles = {
    addButton: {
        backgroundColor: '#EBECFF',
        width: '90px',
        height: '32px',
        border: 'none',
        color: '#0036C8',
        fontSize: '10pt',
        fontWeight: '500',
        borderRadius: '4px',
        float: 'right' as const,
        marginRight: '10px'
    }
};

export const EmailNotifications = (): JSX.Element => {
    const [openAddEmailListModal, setOpenAddEmailListModal] = useToggle(false);
    const [openAddTeamModal, setOpenAddTeamModal] = useToggle(false);

    const dispatch = useAppDispatch();
    useEffect(() => {
        dispatch(getEmailNotificationsGroupsAsync());
    }, []);

    return (
        <Container className='Admin' fluid>
            <AdminSidebar />
            <div className='DataAnonBody'>
                <div style={{ maxWidth: '85%' }}>
                    <label className='dataAnonTableLabel'>Notifications</label>
                    <Button
                        title='Add Email'
                        size='sm'
                        type='Button'
                        onClick={() => {
                            setOpenAddEmailListModal(true);
                        }}
                        style={styles.addButton}
                    >
                        Add Email
                    </Button>
                    <Button
                        title='Add Team'
                        size='sm'
                        type='Button'
                        onClick={() => {
                            setOpenAddTeamModal(true);
                        }}
                        style={styles.addButton}
                    >
                        Add Team
                    </Button>
                </div>
                {openAddEmailListModal && (
                    <EmailNotificationsGroup
                        groupType={EMAIL_GROUP_TYPES.EMAIL_LIST as EmailGroupType}
                        isVisible={setOpenAddEmailListModal}
                    />
                )}
                {openAddTeamModal && (
                    <EmailNotificationsGroup
                        groupType={EMAIL_GROUP_TYPES.TEAM as EmailGroupType}
                        isVisible={setOpenAddTeamModal}
                    />
                )}

                <br />

                <label className='dataAnonTableLabel'>Event Start</label>
                <EmailNotificationsGroupTable
                    groupType={EMAIL_GROUP_TYPES.EMAIL_LIST as EmailGroupType}
                    eventStatus={EVENT_STATUS_TYPES.OPEN_EVENT as EventStatusType}
                />
                <EmailNotificationsGroupTable
                    groupType={EMAIL_GROUP_TYPES.TEAM as EmailGroupType}
                    eventStatus={EVENT_STATUS_TYPES.OPEN_EVENT as EventStatusType}
                />

                <br />

                <label className='dataAnonTableLabel'>Event Complete</label>
                <EmailNotificationsGroupTable
                    groupType={EMAIL_GROUP_TYPES.EMAIL_LIST as EmailGroupType}
                    eventStatus={EVENT_STATUS_TYPES.CLOSE_EVENT as EventStatusType}
                />
                <EmailNotificationsGroupTable
                    groupType={EMAIL_GROUP_TYPES.TEAM as EmailGroupType}
                    eventStatus={EVENT_STATUS_TYPES.CLOSE_EVENT as EventStatusType}
                />

                <br />

                <label className='dataAnonTableLabel'>Event Reopen</label>
                <EmailNotificationsGroupTable
                    groupType={EMAIL_GROUP_TYPES.EMAIL_LIST as EmailGroupType}
                    eventStatus={EVENT_STATUS_TYPES.REOPEN_EVENT as EventStatusType}
                />
                <EmailNotificationsGroupTable
                    groupType={EMAIL_GROUP_TYPES.TEAM as EmailGroupType}
                    eventStatus={EVENT_STATUS_TYPES.REOPEN_EVENT as EventStatusType}
                />

                <br />

                <label className='dataAnonTableLabel'>Event End</label>
                <EmailNotificationsGroupTable
                    groupType={EMAIL_GROUP_TYPES.EMAIL_LIST as EmailGroupType}
                    eventStatus={EVENT_STATUS_TYPES.END_EVENT as EventStatusType}
                />
                <EmailNotificationsGroupTable
                    groupType={EMAIL_GROUP_TYPES.TEAM as EmailGroupType}
                    eventStatus={EVENT_STATUS_TYPES.END_EVENT as EventStatusType}
                />
            </div>
        </Container>
    );
};
